// TODO: fix resolveCssVariable usage
// import { resolveCssVariable } from "@/shared/lib/utils";
import { type ThemeConfig } from "antd";

// TODO: invent more advanced system for not handling every token - it is too complicated
export const theme: ThemeConfig = {
  cssVar: true,

  token: {
    borderRadius: 8,
    borderRadiusLG: 16,

    colorBgContainer: "#ffffff",
    colorBgElevated: "#ffffff",
    colorBgLayout: "#f5f5f5",

    colorBorder: "#D1D1D6",
    colorBorderSecondary: "#C7C7CC",

    colorError: "#ff3b30",
    colorInfo: "#4781e9",
    colorPrimary: "#4781e9",
    colorSuccess: "#57e947",
    colorWarning: "#ff9500",

    colorText: "#1E1E1E",
    colorTextBase: "#1e1e1e",
    colorTextHeading: "#1E1E1E",
    colorTextQuaternary: "#0F0F0FC2",
    colorTextTertiary: "#DCE4F214",

    fontFamily: "Inter, sans-serif",
    fontSize: 17,
    fontWeightStrong: 600,

    lineWidth: 1,
    lineWidthBold: 2,
    lineWidthFocus: 3,

    screenMD: 768,
    screenLG: 1024,
    screenXL: 1280,
  },
  components: {
    Layout: {
      bodyBg: "var(--fill-secondary)",
      colorText: "var(--text-primary)",
      footerPadding: "0",
      headerBg: "var(--color-white)",
      headerHeight: 104,
      headerPadding: "24px",
      lightSiderBg: "var(--color-white)",
      lightTriggerColor: "var(--color-white)",
      siderBg: "var(--color-white)",
      triggerBg: "var(--color-white)",
      zeroTriggerHeight: 0,
      zeroTriggerWidth: 0,
    },
    ColorPicker: {
      controlHeight: 34,
      controlHeightLG: 34,
      controlHeightSM: 34,
      controlHeightXS: 34,
    },
    Form: {
      fontSize: 12,
      itemMarginBottom: 0,
    },

    Dropdown: {
      colorText: "var(--global-token-text-color-text)",
      colorTextPlaceholder: "var(--global-token-text-color-text-placeholder)",
      colorIcon: "var(--global-token-icon-color-icon-primary)",
      borderRadius: 12,
    },

    Steps: {
      iconSizeSM: 44,
    },

    Menu: {
      activeBarBorderWidth: 1,
      activeBarHeight: 2,
      activeBarWidth: 0,
      collapsedIconSize: 16,
      collapsedWidth: 80,
      dangerItemActiveBg: "var(--red-red-1)",
      dangerItemColor: "var(--red-red-5)",
      dangerItemHoverColor: "var(--red-red-5)",
      dangerItemSelectedBg: "var(--red-red-1)",
      dangerItemSelectedColor: "var(--red-red-5)",
      darkDangerItemActiveBg: "var(--red-red-5)",
      darkDangerItemColor: "var(--red-red-5)",
      darkDangerItemHoverColor: "var(--red-red-4)",
      darkDangerItemSelectedBg: "var(--red-red-5)",
      darkDangerItemSelectedColor: "var(--neutral-gray-1)",
      darkGroupTitleColor: "var(--transparent-white-65)",
      darkItemBg: "var()",
      darkItemColor: "var()",
      darkItemDisabledColor: "var()",
      darkItemHoverColor: "var()",
      darkItemSelectedBg: "var()",
      darkItemSelectedColor: "var()",
      darkPopupBg: "var()",
      darkSubMenuItemBg: "var()",
      dropdownWidth: 160,
      borderRadiusLG: 12,
      fontSize: 17,
      horizontalItemBorderRadius: 0,
      horizontalLineHeight: "46px",
      iconMarginInlineEnd: 8,
      iconSize: 24,
      itemBg: "var(--color-white)",
      itemBorderRadius: 8,
      itemHeight: 56,
      itemMarginBlock: 8,
      itemMarginInline: 24,
      itemPaddingInline: 16,
      subMenuItemBorderRadius: 4,
      zIndexPopup: 1050,
    },

    Divider: {
      margin: 0,
    },

    Table: {
      headerSplitColor: "",
      borderColor: "var(--data-display-table-border-color)",
      stickyScrollBarBg: "var(--data-display-table-color-bg-container)",
    },

    Pagination: {
      itemActiveBg: "var(--neutral-gray-1)",
      itemInputBg: "var(--neutral-gray-1)",
      itemLinkBg: "var(--neutral-gray-1)",
      itemSize: 32,
      borderRadius: 16,
      borderRadiusLG: 16,
      borderRadiusSM: 16,
      fontWeightStrong: 400,
      margin: 16,
    },

    Button: {
      borderRadius: 12,
      borderRadiusSM: 8,
      primaryColor: "var(--global-token-text-color-text-light-solid)",
      colorPrimaryBg: "var(--general-button-primary-bg)",
      colorPrimaryBgHover: "var(--general-button-primary-hover-bg)",
      colorPrimaryTextHover: "var(--global-token-primary-color-primary-text)",
      colorTextDisabled: "var(--global-token-text-color-text-disabled)",
      colorBgContainerDisabled: "var(--general-button-primary-disabled-bg)",
      colorError: "var(--global-token-error-color-error)",
      colorErrorHover: "var(--global-token-error-color-error-bg-hover)",
      colorBorder: "transparent",
      defaultBg: "var(--general-button-default-bg)",
      defaultColor: "var(--global-token-primary-color-primary-text)",
      defaultHoverBg: "var(--general-button-default-hover-bg)",
      defaultHoverBorderColor: "var(--general-button-default-border-color)",
      defaultActiveBg: "var(--general-button-default-hover-bg)",
      defaultActiveBorderColor: "var(--general-button-default-border-color)",
      defaultActiveColor: "var(--global-token-primary-color-primary-text)",
      paddingBlock: "var(--general-button-padding-block)",
      paddingInline: "var(--general-button-padding-inline-lg)",
      paddingBlockLG: "var(--general-button-padding-block-lg)",
      paddingInlineLG: "var(--general-button-padding-inline-lg)",
      paddingBlockSM: "var(--general-button-padding-block-sm)",
      paddingInlineSM: "var(--general-button-padding-inline-lg)",
      controlHeight: 56,
      controlHeightLG: 56,
      controlHeightSM: 36,
    },

    Input: {
      activeBorderColor: "var(--data-entry-input-active-border-color)",
      addonBg: "var(--data-entry-input-addon-bg)",
      borderRadius: 12,
      hoverBg: "var(--data-entry-input-hover-bg)",
      hoverBorderColor: "var(--data-entry-input-hover-border-color)",
      inputFontSize: 14,
      inputFontSizeLG: 16,
      inputFontSizeSM: 14,
      paddingBlock: 12,
      paddingBlockLG: 20,
      paddingBlockSM: 0,
      paddingInline: 12,
      paddingInlineLG: 20,
      paddingInlineSM: 7,
    },

    InputNumber: {
      activeBorderColor: "var(--data-entry-input-active-border-color)",
      addonBg: "var(--data-entry-input-addon-bg)",
      borderRadius: 12,
      hoverBg: "var(--data-entry-input-hover-bg)",
      hoverBorderColor: "var(--data-entry-input-hover-border-color)",
      inputFontSize: 14,
      inputFontSizeLG: 16,
      inputFontSizeSM: 14,
      paddingBlock: 12,
      paddingBlockLG: 20,
      paddingBlockSM: 0,
      paddingInline: 12,
      paddingInlineLG: 20,
      paddingInlineSM: 7,
      controlHeight: 44,
    },

    Card: {
      bodyPadding: 24,
      bodyPaddingSM: 0,
      boxShadow: "",
      boxShadowTertiary: "",
      boxShadowSecondary: "",
    },

    Tabs: {
      horizontalItemPaddingSM: "var(--data-display-tabs-horizontal-item-padding)",
      cardPaddingSM: "var(--data-display-tabs-card-padding)",
      itemHoverColor: "var(--data-display-tabs-item-hover-color)",
      itemSelectedColor: "var(--data-display-tabs-item-selected-color)",
      colorTextDisabled: "var(--data-display-tabs-item-disabled-color)",
      inkBarColor: "var(--data-display-tabs-ink-bar-color)",
      lineWidthFocus: 3,
      lineWidth: 1,
      colorBorder: "var(--global-token-border-color-border)",
    },

    Select: {
      controlHeight: 44,
      controlHeightSM: 44,
      borderRadius: 6,
      colorBorder: "var(--data-entry-input-addon-bg)",
      selectorBg: "var(--data-entry-input-addon-bg)",
      paddingContentHorizontalLG: 12,
      paddingContentVerticalLG: 12,

      optionFontSize: 13,
    },

    Checkbox: {
      controlInteractiveSize: 24,
    },
  },
};
